import { useEffect, useState } from 'react';
import { Location, useLocation, useNavigationType } from 'react-router';

interface NavigationHistoryState {
  currentLocation: Location;
  previousLocation: Location;
}

export const useNavigationHistory = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  const [history, setHistory] = useState<NavigationHistoryState>({
    currentLocation: location,
    previousLocation: {
      ...location,
      pathname: '/',
      key: 'default',
    },
  });

  useEffect(() => {
    const isSamePage = (prevLocation: Location, newLocation: Location) => {
      return (
        prevLocation.key === newLocation.key ||
        prevLocation.pathname === newLocation.pathname
      );
    };
    setHistory((previousState) => {
      // Only update previous if the new location is not a duplicate
      if (isSamePage(previousState.currentLocation, location)) {
        return previousState;
      }

      // If navigation was a REPLACE, do not update previousLocation
      if (navigationType === 'REPLACE') {
        return {
          previousLocation: previousState.previousLocation,
          currentLocation: location,
        };
      }

      return {
        previousLocation: previousState.currentLocation,
        currentLocation: location,
      };
    });
  }, [location, navigationType]);

  return history;
};
